function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16.499 3.186a8.347 8.347 0 00-4.777-1.01 8.196 8.196 0 00-4.499 1.838 7.86 7.86 0 00-2.37 8.85 8.11 8.11 0 002.99 3.816 8.335 8.335 0 004.439 1.468l-2.338 2.247a1.013 1.013 0 00-.212.707c.02.253.136.493.325.674a1.143 1.143 0 001.442.11l4.376-4.192c.2-.196.312-.461.31-.737a1.051 1.051 0 00-.322-.742l-4.443-4.26a1.15 1.15 0 00-.741-.213 1.106 1.106 0 00-.7.301 1.02 1.02 0 00-.09 1.38h-.012l2.883 2.762a.998.998 0 00-.243-.032 6.339 6.339 0 01-3.536-1.119 6.112 6.112 0 01-2.255-2.873 5.86 5.86 0 011.771-6.606 6.196 6.196 0 013.401-1.387 6.347 6.347 0 013.632.768c1.061.587 1.72.564 1.97.064.5-1-.14-1.337-1.001-1.814z",
  clipRule: "evenodd"
});

var SvgCounterclockwise = function SvgCounterclockwise(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgCounterclockwise;